import { ClipboardCheck, Loader2 } from 'lucide-react';
import { StaticMetricCardAlt } from '@/components/StaticMetricCardAlt';
import { useAuditStatus } from '@/hooks/use-asset-management-widgets';
import { Card, CardContent } from '@/components/ui/card';

interface KpiAuditsPendingProps {
  readonly className?: string;
}

export function KpiAuditsPending({ className }: KpiAuditsPendingProps): React.ReactElement {
  const { data, isLoading } = useAuditStatus();

  const totalActiveAudits = data?.totalActiveAudits ?? 0;
  const averageCompletion = data?.averageCompletion ?? 0;

  if (isLoading) {
    return (
      <Card className="overflow-hidden border-0">
        <CardContent className="p-6 h-[148px] flex flex-col items-center justify-center">
          <Loader2 className="h-8 w-8 animate-spin text-muted-foreground" />
          <span className="text-sm text-muted-foreground mt-2">Loading...</span>
        </CardContent>
      </Card>
    );
  }

  return (
    <StaticMetricCardAlt
      title="Active Audits"
      value={totalActiveAudits.toString()}
      change={`${averageCompletion.toFixed(0)}%`}
      changeLabel="avg completion"
      icon={ClipboardCheck}
      variant="info"
    />
  );
}
